module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/videos/term-bg-5-6368916ee85a221e8f8c1ca48d7e63bc.jpg";